import type { GridListProps } from '@bos/ui';
import { GridList } from '@bos/ui';

import { appSizes } from '../const/appSizes';

type AppGridListProps = Omit<GridListProps, 'itemMinWidth'>;

export const AppGridList = (props: AppGridListProps) => (
	<GridList itemMinWidth={appSizes.grid.itemMinWidth} {...props} />
);
